export interface IGeocodedLocationAPI {
  id: number;
  name: string;
  description: string;
  lat: number;
  lng: number;
  type: string;
  externalID?: string;
  imageUri?: string;
  liftData?; // Adjust the type as per the actual type of liftData
}

export default class GeocodedLocation {
  id: number;

  name: string;

  description: string;

  lat: number;

  lng: number;

  type: string; // 's' = Site, 'u' = Unit

  externalID?: string;

  imageUri?: string;

  liftData?;

  constructor(
    id = -1,
    name: string,
    description: string,
    lat: number,
    lng: number,
    type: string,
    externalID?: string,
    imageUri?: string,
    liftData = null,
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.lat = lat;
    this.lng = lng;
    this.type = type;
    this.externalID = externalID;
    this.imageUri = imageUri;
    this.liftData = liftData;
  }

  static fromApi(apiObject: IGeocodedLocationAPI): GeocodedLocation {
    return new GeocodedLocation(
      apiObject.id,
      apiObject.name,
      apiObject.description,
      apiObject.lat,
      apiObject.lng,
      apiObject.type,
    );
  }
}
